export const POSTHOG_EVENTS = {
  NAV_SHORTCUT_USED: 'navigation:shortcut_use',
} as const;
